import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import React from 'react';
import { colors, VerifiedIcon } from '@chegg-ui/theme';
import { AvatarImg, AvatarContainer, AvatarCircle, AvatarContent } from '../styles';

var getInitial = function getInitial(str) {
  return str && str.charAt(0).toUpperCase();
};

var getName = function getName(name, email) {
  if (name) {
    var nameArray = name.split(' ');

    if (nameArray.length > 1) {
      return "".concat(nameArray[0], " ").concat(nameArray[nameArray.length - 1].slice(0, 1), ".");
    }

    return nameArray[0];
  }

  return email && email.split('@')[0];
};

var Avatar = function Avatar(props) {
  var name = props.name,
      email = props.email,
      image = props.image,
      isVerified = props.isVerified,
      size = props.size,
      rest = _objectWithoutProperties(props, ["name", "email", "image", "isVerified", "size"]);

  var initials = !isVerified ? getInitial(name || email) : '';
  return /*#__PURE__*/React.createElement(AvatarContainer, rest, image ? /*#__PURE__*/React.createElement(AvatarImg, {
    size: size,
    src: image.src,
    alt: image.alt
  }) : /*#__PURE__*/React.createElement(AvatarCircle, {
    size: size
  }, initials), size === 'small' && /*#__PURE__*/React.createElement(AvatarContent, null, isVerified ? name : getName(name, email), isVerified ? /*#__PURE__*/React.createElement(React.Fragment, null, '\xa0\xa0', /*#__PURE__*/React.createElement(VerifiedIcon, {
    size: "xsmall",
    svgColor: colors.sky
  })) : ''));
};

Avatar.displayName = 'Avatar';
export default Avatar;